/* eslint-disable prettier/prettier */
import { useEffect, useState, useCallback } from 'react';
import { assessmentService } from '../services/assessment.service';

export interface AssessmentStatusMap {
	[assessmentId: string]: {
		has_submitted: boolean;
		submission_id?: string;
		passed?: boolean | null;
		submitted_at?: string | Date | null;
		file_name?: string | null;
	};
}

export function useCourseAssessmentStatuses(courseId?: string) {
	const [statuses, setStatuses] = useState<AssessmentStatusMap>({});
	const [loading, setLoading] = useState(false);

	const fetchStatuses = useCallback(async () => {
		if (!courseId) return;

		setLoading(true);
		try {
			const data =
				await assessmentService.getCourseAssessmentsStatus(courseId);
			console.log('📡 Hook: Raw Status API Response:', data);

			const map: AssessmentStatusMap = {};

			data.forEach((item: any) => {
				// ⚠️ DOUBLE CHECK THESE KEYS:
				// Use || to fallback if the API uses underscores or camelCase
				const id = item.assessmentid || item.assessment_id || item.id;
				const submitted =
					item.hassubmitted ?? item.has_submitted ?? false;
				const subId = item.submissionid || item.submission_id;

				const passed = item.passed ?? null;
				const submittedAt =
					item.submitted_at ?? item.submittedat ?? null;
				const fileName = item.file_name ?? item.filename ?? null;

				if (id) {
					map[id] = {
						has_submitted: !!submitted, // ensures boolean
						submission_id: subId,
						passed,
						submitted_at: submittedAt,
						file_name: fileName,
					};
				}
			});

			console.log('🗺️ Hook: Transformed Map:', map);
			setStatuses(map);
		} catch (error) {
			console.error('❌ Hook: Failed to fetch statuses', error);
		} finally {
			setLoading(false);
		}
	}, [courseId]);

	useEffect(() => {
		fetchStatuses();
	}, [fetchStatuses]);

	return { statuses, loading, setStatuses, refetch: fetchStatuses };
}
